import { CloseOutlined, ExclamationOutlined, LikeFilled } from "@ant-design/icons";
import { Button, Card, Col, Form, Result, Row, TimePicker, Typography, message, Avatar, Divider, List, Skeleton, Checkbox, Space, DatePicker, Select, Badge, ConfigProvider } from "antd"
import axios from "axios";
import dayjs from 'dayjs'
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
const CheckboxGroup = Checkbox.Group;

const PunchReservation = ({
    mode = "reserve" //reserve or QRcodePunch
}) => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [emergencyContact, setEmergencyContact] = useState([])
    const [rollCall, setRollCall] = useState(false);
    const [student, setStudent] = useState([])
    const [checkedList, setCheckedList] = useState([]);
    const { state, GradeClassId } = useParams()

    const onChange = (list) => {
        setCheckedList(list);
        let itemFormData = form.getFieldsValue()?.items ?? []
        let newItems = list.map((user_id) => {
            let info = itemFormData.find((element) => element?.user_id === user_id)
            if (!info) {
                info = student.find((element) => element?.user_id === user_id)
            }
            return info
        })
        form.setFieldValue('items', newItems)

    };
    const onFinish = () => {
        getStudent()
        setCheckedList([])
        form.setFieldsValue({
            items: []
        })
    }
    const updateAllDate = (index) => {
        let newDate = form.getFieldValue(["items", index, "date"])
        let items = form.getFieldValue("items")
        let newItems = items.map((value) => {
            return {
                ...value,
                date: newDate
            }
        })
        form.setFieldValue('items', newItems)
    }
    const getStudent = () => {
        axios
            .get('/cramSchool/api/grade_class_student_self', {
                params: {
                    ...(!isNaN(GradeClassId)? { grade_class_id: GradeClassId }:{})
            }
            })
            .then(response => {
                setStudent(response.data?.data[0])
                // if (response.data?.data[0].roll_call_status == 1) {
                //     setRollCall(true)
                // }
            })
    }

useEffect(() => {
    getStudent()
}, [])
const handleRollCall = () => {
    axios
        .post('/cramSchool/api/class/management', [{
            grade_class_id: student?.grade_class_id,
            user_id: student?.user_id,
            class_id: 1,
            date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        }])
        .then((response) => {
            if (response.data.status == 'success') {
                navigate(`/cramSchool/PunchOut/${state}`)
            } else {
                message.error('簽到失敗')
            }
        })
}
return (<>
    <Card>

        <Row gutter={[8, 16]}>
            <Col>
                <Typography.Title level={2}>課堂簽到</Typography.Title>
            </Col>
            <Col span={24}>
                姓名：{student?.student_name}同學
            </Col>
            <Col span={24}>
                學號：{student?.serial_name}
            </Col>
            <Col span={24}>
                課堂名稱：{student?.class_name}
            </Col>
            {rollCall == true ? <>
                <Col span={24}>
                    <Result
                        title="你已打卡過"
                    />
                </Col>
            </> : <>
                <Col span={24} onClick={handleRollCall}>
                    <Button type='primary' block>確認上課簽到</Button>
                </Col>
            </>}
        </Row>
        {/* <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Form
                        name={"all"}
                        form={form}
                        onFinish={(values) => {
                            if (mode === 'reserve') {
                                let student_data = values?.items
                                if (student_data && student_data.length > 0) {
                                    let emergency_contact_id = emergencyContact.find(e => true)?.emergency_contact_id
                                    let data = student_data?.map((value) => {
                                        console.log(value?.date)
                                        let date = dayjs(value?.date).format('YYYY-MM-DD HH:mm')
                                        return {
                                            "user_id": value?.user_id,
                                            "pickup_emergency_contact_id": value?.pickup_emergency_contact_id,
                                            "reservation_emergency_contact_id": emergency_contact_id,
                                            date: date,
                                            remark: value?.remark,
                                            class_id: 1
                                        }
                                    })
                                    axios
                                        .post('/cramSchool/api/class/management', data)
                                        .then(response => {
                                            message.success('預約成功')
                                        })
                                        .catch(() => {
                                            message.error('預約失敗')
                                        })
                                        .finally(() => {
                                            onFinish()
                                        })
                                }
                                else {
                                    message.info("請至少選擇一個您要預約的小孩喔～")
                                }
                            }
                            else {
                                if (checkedList.length > 0) {
                                    let pickup_emergency_contact_id = emergencyContact.find(e => true)?.emergency_contact_id

                                    let data = checkedList.map((user_id) => {
                                        return {
                                            "patrol_location_punch_value": state,
                                            "user_id": user_id,
                                            "pickup_emergency_contact_id": pickup_emergency_contact_id
                                        }
                                    })
                                    console.log(data)
                                    axios
                                        .post('/cramSchool/api/punch_out', data)
                                        .then(response => {
                                            message.success('打卡成功')
                                        })
                                        .catch(() => {
                                            message.error('打卡成功')
                                        })
                                        .finally(() => {
                                            onFinish()
                                        })
                                }
                                else {
                                    message.info("請至少選擇一個您要接送的小孩喔～")

                                }
                            }

                        }}
                    >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                {emergencyContact.map(map_item => (<>
                                    <Typography.Title level={5}>{map_item.emergency_contact_name} 先生／小姐，您好</Typography.Title>
                                    <Row>
                                        {student && (<>
                                            <Col span={24}>
                                                您是：{student.map((map_item_item, map_item_index) => map_item_item.name).join('、')}的家長
                                            </Col>
                                        </>)}
                                    </Row>
                                </>))}
                            </Col>
                            <Col span={24}>
                                <Space direction="vertical">
                                    <Typography.Title level={5}>{`請您選擇今天要${mode === "reserve" ? "預約" : "接送"}的對象`}</Typography.Title>
                                    <CheckboxGroup
                                        options={student.map((studentData) => {
                                            if (mode === "reserve") {
                                                return {
                                                    label: !!(studentData?.reservation_status === 1) ? `${studentData?.name} (已預約)` : `${studentData?.name}`,
                                                    value: studentData?.user_id,
                                                    disabled: !!(studentData?.reservation_status === 1)
                                                }
                                            }
                                            else {
                                                return {
                                                    label: !!(studentData?.pickup_status === 1) ? `${studentData?.name} (已接送)` : `${studentData?.name}`,
                                                    value: studentData?.user_id,
                                                    disabled: !!(studentData?.pickup_status === 1)
                                                }
                                            }

                                        })}
                                        value={checkedList}
                                        onChange={onChange}
                                    />
                                </Space>

                            </Col>
                            {
                                mode === "reserve" ?
                                    (<Col span={24}>
                                        <Form.List name="items">
                                            {(fields) => (
                                                <Row gutter={[12, 12]}>
                                                    {fields.map((field) => (
                                                        <Col
                                                            xxl={8}
                                                            xl={8}
                                                            lg={8}
                                                            md={12}
                                                            sm={12}
                                                            xs={24}
                                                        >
                                                            <Card
                                                                size="small"
                                                                // title={`Item ${field.name + 1}`}
                                                                key={field.key}

                                                            >
                                                                <Row gutter={[12, 12]}>
                                                                    <Col
                                                                        xxl={24}
                                                                        xl={24}
                                                                        lg={24}
                                                                        md={24}
                                                                        sm={24}
                                                                        xs={24}
                                                                    >
                                                                        <Form.Item
                                                                            hidden={true}
                                                                            label={''}
                                                                            name={[field.name, 'user_id']}
                                                                        >
                                                                            <Input
                                                                                disabled></Input>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col
                                                                        xxl={24}
                                                                        xl={24}
                                                                        lg={24}
                                                                        md={24}
                                                                        sm={24}
                                                                        xs={24}
                                                                    >
                                                                        <Form.Item
                                                                            noStyle
                                                                        >
                                                                            <Typography.Title
                                                                                style={{
                                                                                    margin: 0
                                                                                }}
                                                                                level={3}>
                                                                                {form.getFieldValue(["items", field.name, "name"])}
                                                                            </Typography.Title>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col
                                                                        xxl={24}
                                                                        xl={24}
                                                                        lg={24}
                                                                        md={24}
                                                                        sm={24}
                                                                        xs={24}
                                                                    >
                                                                        <Space align="top" wrap>
                                                                            <Form.Item
                                                                                label={'預約時間'}
                                                                                name={[field.name, 'date']}
                                                                                initialValue={dayjs()}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "請選擇預約時間"
                                                                                    }
                                                                                ]}
                                                                            >
                                                                                <TimePicker
                                                                                    minuteStep={15}
                                                                                    format="h:mm A"
                                                                                    changeOnBlur
                                                                                />
                                                                            </Form.Item>
                                                                            <Button
                                                                                type='primary'
                                                                                onClick={() => {
                                                                                    updateAllDate(field.name)
                                                                                }}
                                                                            >統一帶入此預約時間</Button>
                                                                        </Space>
                                                                    </Col>
                                                                    <Col
                                                                        xxl={24}
                                                                        xl={24}
                                                                        lg={24}
                                                                        md={24}
                                                                        sm={24}
                                                                        xs={24}
                                                                    >
                                                                        <Form.Item
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "請選擇接送人"
                                                                                }
                                                                            ]}
                                                                            label={'接送人'}
                                                                            name={[field.name, 'pickup_emergency_contact_id']}
                                                                        >
                                                                            <Select
                                                                                allowClear={true}
                                                                                showSearch
                                                                                optionFilterProp="children"
                                                                                options={student[field?.name]?.emergency_contact_data.map(item => (
                                                                                    {
                                                                                        label: item?.emergency_contact_name,
                                                                                        value: item?.emergency_contact_id
                                                                                    }))}
                                                                                filterOption={(input, option) => {
                                                                                    return (option?.label ?? '').includes(input)
                                                                                }}

                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col
                                                                        xxl={24}
                                                                        xl={24}
                                                                        lg={24}
                                                                        md={24}
                                                                        sm={24}
                                                                        xs={24}
                                                                    >
                                                                        <Form.Item
                                                                            label={'備註'}
                                                                            name={[field.name, 'remark']}
                                                                        >
                                                                            <Input.TextArea />
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        </Col>

                                                    ))}
                                                </Row>
                                            )}
                                        </Form.List>

                                    </Col>) :
                                    <></>
                            }

                            <Col span={24}>
                                <Form.Item>
                                    <ConfigProvider
                                        theme={{
                                            token: {
                                                colorPrimary: mode === 'reserve' ? 'rgb(83, 183, 173)' : '#f09a45',
                                            },
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit" block>
                                            送出
                                        </Button>
                                    </ConfigProvider>

                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col
                    xxl={12}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                >
                    {
                        mode === "reserve" ?
                            (
                                <ReserveHistory />
                            )
                            : (
                                // <PunchHistory />
                            )
                    }
                </Col>
            </Row> */}
    </Card >
</>)
}
const ReserveHistory = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [listInformation, setListInformation] = useState({
        total: 0,
        cur_page: 0,
        size: 10
    })
    const [punchRecordDate, setPunchRecordDate] = useState([])
    const loadMoreData = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        // axios
        //     .get('/cramSchool/api/staff_class_record_per', {
        //         params: {
        //             cur_page: listInformation?.cur_page + 1,
        //             size: listInformation?.size,
        //         }
        //     })
        //     .then(response => {
        //         let newData = response.data?.data
        //         let total = response.data?.total
        //         setData([...data, ...newData]);
        //         setListInformation((pre) => {
        //             return {
        //                 total: total,
        //                 cur_page: pre?.cur_page + 1,
        //                 size: pre?.size
        //             }
        //         })
        //         setLoading(false);
        //     })

    };
    useEffect(() => {
        loadMoreData();
    }, []);


    useEffect(() => {
        if (punchRecordDate && punchRecordDate.length > 0) {
            if (loading) {
                return;
            }
            setLoading(true);
            axios
                .get('/cramSchool/api/staff_class_record_per', {
                    params: {
                        cur_page: 1,
                        size: listInformation?.size,
                        staff_class_record_date_start: dayjs(punchRecordDate[0]).format("YYYY-MM-DD"),
                        staff_class_record_date_end: dayjs(punchRecordDate[1]).format("YYYY-MM-DD"),
                    }
                })
                .then(response => {
                    let newData = response.data?.data
                    let total = response.data?.total
                    setData([...newData]);
                    setListInformation((pre) => {
                        return {
                            total: total,
                            cur_page: 1,
                            size: pre?.size
                        }
                    })
                    setLoading(false);

                })
        }
        else {
            if (loading) {
                return;
            }
            setLoading(true);
            // axios
            //     .get('/cramSchool/api/staff_class_record_per', {
            //         params: {
            //             cur_page: 1,
            //             size: listInformation?.size,
            //         }
            //     })
            //     .then(response => {
            //         let newData = response.data?.data
            //         let total = response.data?.total
            //         setData([...newData]);
            //         setListInformation((pre) => {
            //             return {
            //                 total: total,
            //                 cur_page: 1,
            //                 size: pre?.size
            //             }
            //         })
            //         setLoading(false);

            //     })
        }
    }, [punchRecordDate])
    return (
        <Card>
            <Row>
                <Col>
                    <Typography.Title level={3}>
                        歷史預約紀錄
                    </Typography.Title>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"查詢時間"}
                    >
                        <DatePicker.RangePicker
                            value={punchRecordDate}
                            onChange={(date) => {
                                setPunchRecordDate(date)
                            }}
                            format={"YYYY-MM-DD"} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <div>
                        <InfiniteScroll
                            dataLength={data.length}
                            next={loadMoreData}
                            hasMore={data.length < listInformation.total}
                            loader={
                                <Skeleton
                                    avatar
                                    paragraph={{
                                        rows: 1,
                                    }}
                                    active
                                />
                            }
                            endMessage={<Divider plain>已經沒有更多資料了喔～</Divider>}


                        >
                            <Row>
                                <Col span={24}>
                                    <List
                                        dataSource={data}
                                        renderItem={(item) => (
                                            <List.Item key={item.email}>
                                                <Row gutter={[8, 8]} align={"middle"}>
                                                    <Col>
                                                        <Avatar
                                                            style={{ backgroundColor: '#417586' }}
                                                            size={"large"}
                                                        >
                                                            {item?.student_name}
                                                        </Avatar>
                                                    </Col>
                                                    <Col>
                                                        <Avatar
                                                            style={{ backgroundColor: item?.punch_record_time ? '#56b673' : '#f09a45' }}
                                                            icon={item?.punch_record_time ? <LikeFilled /> : <ExclamationOutlined />}
                                                            size={"large"}
                                                        />
                                                    </Col>
                                                    <Col>

                                                        <Card
                                                            size="small"
                                                            style={{
                                                                background: "#fee9cb"
                                                            }}
                                                        >
                                                            {item?.staff_class_record_date}
                                                        </Card>

                                                    </Col>
                                                    <Col>
                                                        <Space direction='horizontal' wrap>
                                                            <>
                                                                預計接送： {item?.staff_class_record_time || '-'}({item?.pickup_emergency_contact_name || '-'})
                                                            </>
                                                            <>
                                                                實際接送：  {item?.punch_record_time || '-'}( )
                                                            </>
                                                        </Space>
                                                    </Col>

                                                </Row>
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
                        </InfiniteScroll>
                    </div>
                </Col>
            </Row>


        </Card>

    );

}
const PunchHistory = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [listInformation, setListInformation] = useState({
        total: 0,
        cur_page: 0,
        size: 10
    })
    const [punchRecordDate, setPunchRecordDate] = useState([])
    const loadMoreData = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        axios
            .get('/cramSchool/api/punch_record_per', {
                params: {
                    cur_page: listInformation?.cur_page + 1,
                    size: listInformation?.size,
                }
            })
            .then(response => {
                let newData = response.data?.data
                let total = response.data?.total
                setData([...data, ...newData]);
                setListInformation((pre) => {
                    return {
                        total: total,
                        cur_page: pre?.cur_page + 1,
                        size: pre?.size
                    }
                })
                setLoading(false);
            })

    };
    useEffect(() => {
        loadMoreData();
    }, []);


    useEffect(() => {
        if (punchRecordDate && punchRecordDate.length > 0) {
            if (loading) {
                return;
            }
            setLoading(true);
            axios
                .get('/cramSchool/api/punch_record_per', {
                    params: {
                        cur_page: 1,
                        size: listInformation?.size,
                        punch_record_date_start: dayjs(punchRecordDate[0]).format("YYYY-MM-DD"),
                        punch_record_date_end: dayjs(punchRecordDate[1]).format("YYYY-MM-DD"),
                    }
                })
                .then(response => {
                    let newData = response.data?.data
                    let total = response.data?.total
                    setData([...newData]);
                    setListInformation((pre) => {
                        return {
                            total: total,
                            cur_page: 1,
                            size: pre?.size
                        }
                    })
                    setLoading(false);

                })
        }
        else {
            if (loading) {
                return;
            }
            setLoading(true);
            axios
                .get('/cramSchool/api/punch_record_per', {
                    params: {
                        cur_page: 1,
                        size: listInformation?.size,
                    }
                })
                .then(response => {
                    let newData = response.data?.data
                    let total = response.data?.total
                    setData([...newData]);
                    setListInformation((pre) => {
                        return {
                            total: total,
                            cur_page: 1,
                            size: pre?.size
                        }
                    })
                    setLoading(false);

                })
        }
    }, [punchRecordDate])
    return (
        <Card>
            <Row>
                <Col>
                    <Typography.Title level={3}>
                        歷史打卡紀錄
                    </Typography.Title>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"查詢時間"}
                    >
                        <DatePicker.RangePicker
                            value={punchRecordDate}
                            onChange={(date) => {
                                setPunchRecordDate(date)
                            }}
                            format={"YYYY-MM-DD"} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <div>
                        <InfiniteScroll
                            dataLength={data.length}
                            next={loadMoreData}
                            hasMore={data.length < listInformation.total}
                            loader={
                                <Skeleton
                                    avatar
                                    paragraph={{
                                        rows: 1,
                                    }}
                                    active
                                />
                            }
                            endMessage={<Divider plain>已經沒有更多資料了喔～</Divider>}


                        >
                            <Row>
                                <Col span={24}>
                                    <List
                                        dataSource={data}
                                        renderItem={(item) => (
                                            <List.Item key={item.email}>
                                                <Row gutter={[8, 8]} align={"middle"}>
                                                    <Col>
                                                        <Avatar
                                                            style={{ backgroundColor: '#417586' }}
                                                            size={"large"}
                                                        >
                                                            {item?.student_name}
                                                        </Avatar>
                                                    </Col>
                                                    <Col>
                                                        <Avatar
                                                            style={{ backgroundColor: item?.punch_record_time ? '#56b673' : '#f09a45' }}
                                                            icon={item?.punch_record_time ? <LikeFilled /> : <ExclamationOutlined />}
                                                            size={"large"}
                                                        />
                                                    </Col>
                                                    <Col>

                                                        <Card
                                                            size="small"
                                                            style={{
                                                                background: "#fee9cb"
                                                            }}
                                                        >
                                                            {item?.punch_record_date}
                                                        </Card>

                                                    </Col>
                                                    <Col>
                                                        <Space direction='horizontal' wrap>
                                                            <>
                                                                預計接送： {item?.staff_class_record_time || '-'}({item?.pickup_emergency_contact_name || '-'})
                                                            </>
                                                            <>
                                                                實際接送：  {item?.punch_record_time || '-'}({item?.pickup_emergency_contact_name})
                                                            </>
                                                        </Space>
                                                    </Col>

                                                </Row>
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
                        </InfiniteScroll>
                    </div>
                </Col>
            </Row>


        </Card>

    );

}
export default PunchReservation